module.exports = __webpack_public_path__ + "static/media/quote-wenzel-mistakes-fr.02695224.png";